
export const apiField = 'standoff_height';

export enum StandoffHeightOptions {
  THREE_INCH = 3,
  FOUR_INCH = 4,
  SIX_INCH = 6,
  SEVEN_INCH = 7,
} 

function makeConfig(options: object[]) {
  return {
    type: 'Select',
    label: 'standoff_height',
    apiField,
    data: options,
  };
}

export default makeConfig([
  {
    value: StandoffHeightOptions.THREE_INCH,
    name: '3"',
  },
  {
    value: StandoffHeightOptions.FOUR_INCH,
    name: '4"',
  },
  {
    value: StandoffHeightOptions.SIX_INCH,
    name: '6"',
  },
  {
    value: StandoffHeightOptions.SEVEN_INCH,
    name: '7"',
  },
  
  
]);

